import styles from "./spring.module.css";

export const Spring = () => {
    return (
        <div className={styles.spring} />
    )
}